import { scrollBySlide } from "@/utils/scroll-snap";
import type { AttrClass } from "node_modules/marko/tags-html";
import s from "./style.module.css";
export interface Input {
    items: Marko.AttrTag<{ content: Marko.Body }>;
    class?: AttrClass;
    controls?: boolean;
}
<const/{ items, class: className, controls: inputControls = true }=input>
<let/showControls=true>

<div class=[s.container, className]>
    <if=inputControls && showControls>
        <div class=s.controls>
            <icon-button
                class=s.button
                aria-label="Previous slide"
                onClick() {
                    scrollBySlide(carouselRef(), -1);
                }>
                <icon-chevron-left-20/>
            </icon-button>
            <icon-button
                class=s.button
                aria-label="Next slide"
                onClick() {
                    scrollBySlide(carouselRef(), 1);
                }>
                <icon-chevron-right-20/>
            </icon-button>
        </div>
    </if>
    <div/carouselRef
        class=s.carousel
        data-controls=`${inputControls && showControls}`>
        <for|item| of=items>
            <${item.content}/>
        </for>
    </div>
</div>

<script>
    setControlVisibility();
    window.addEventListener("resize", setControlVisibility, {
        signal: $signal,
    });
    function canScroll() {
        return carouselRef().scrollWidth > carouselRef().clientWidth;
    }
    function setControlVisibility() {
        showControls = canScroll();
    }
</script>

<return=carouselRef>
